require("../sass/style.scss");

require("../fonts/fontello/css/fontello.css");

require("./vendor/bootstrap-transition");
require("./vendor/bootstrap-collapse");

require("./custom/fullscreen-search-modal");
require("./custom/main-menu");
require("./custom/general");
require("./custom/parallax");

(function ($) {

    $(".animate-svg").length && require("./custom/animate-svg");
    $(".section-full_screen_hero_banner").length && require("./custom/section-full_screen_hero_banner");
    $(".section-animated-images").length && require("./custom/section-animated-images");
    $(".section-testimonial_slider").length && require("./custom/section-testimonial-slider");
    $(".section-statistic").length && require("./custom/section-statistic");
    $(".success_stories").length && require("./custom/section-success_stories");
    $(".logo_slider").length && require("./custom/logo_slider");
    $(".section-leadership").length && require("./custom/section-leadership");
    $(".section-faq").length && require("./custom/section-faq");
    $(".section-image_banner").length && require("./custom/section-image-banner");
    $(".section-images_slider_with_list").length && require("./custom/section-images_slider_with_list");

})(jQuery);